import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import User from '../shared/Utils/User'
import axios from 'axios';
import Alert from '../shared/Utils/AlertBox';
import Loader from '../shared/components/Loader';
import Moment from 'react-moment';
import { ExcelRenderer, OutTable } from 'react-excel-renderer';
export default function Mapping() {

  const user = User.getUser()
  const [columnsData, setColumnsData] = useState([])
  const [options, setOptions] = useState({ channel: "", lead_name: "", first_name: "", last_name: "", department: "", title: "", seniority: "", linkedinUrl: "", email: "", company: "", companyUrl: "", phone_number: "", work_phone: "" })


  useEffect(() => {
  }, [options])

  function fileHandler(event) {
    let fileObj = event.target.files[0];
    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      }
      else {
        console.log(resp.cols);
        console.log(resp.rows[0]);
        setColumnsData(resp.rows[0]);
      }
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOptions((prev) => ({ ...prev, [name]: value, }));
  };

  return (
    <>
      <DashboardHeader />
      <div className="container-fluid page-body-wrapper">
        <SideMenu />
        <div class="main-panel">
          <div class="content-wrapper">
            <div>
              <b>Import Excel File:</b>
              <div>
                <input type="file" className="fileSelect"
                  onChange={(e) => fileHandler(e)} />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-9">
                        <h4 class="card-title">Column Mapping</h4>
                        <p class="card-description">
                          Note: Map the CSV columns to relevant Getbound fields.
                        </p>
                      </div>
                    </div>
                    <form className="forms-sample">
                      <div className='row'>
                        <div className='col-md-3'>
                          <h4 class="card-title">CSV Column Header</h4>
                          <div className="form-group customformheight">
                            <label>Channel</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Lead Name</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>First Name</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Last Name</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Department</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Title</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Seniority (dir/prt)</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Linkedin</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Email</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Company Name</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Company URL</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Mobile Phone Number</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Work Phone Number</label>
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <h4 class="card-title">Getbound Field</h4>
                          <div className="form-group customformheight">

                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="channel"
                              value={options.channel}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="lead_name"
                              value={options.lead_name}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="first_name"
                              value={options.first_name}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="last_name"
                              value={options.last_name}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="department"
                              value={options.department}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="title"
                              value={options.title}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="seniority"
                              value={options.seniority}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="linkedinUrl"
                              value={options.linkedinUrl}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="email"
                              value={options.email}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="ompany"
                              value={options.company}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="companyUrl"
                              value={options.companyUrl}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="phone_number"
                              value={options.phone_number}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group customformheight">
                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                              onChange={handleChange}
                              name="work_phone"
                              value={options.work_phone}>
                              {columnsData.map((data, index) => (
                                <option key={index} value={index}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className='col-md-5'>
                          <h4 class="card-title">Example Data</h4>
                          <div className="form-group customformheight">
                            <label>Linkedin, Facebook, Twitter</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Warren Thornton, Zelene Goodwin, Lance Cross</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Winston Nguyen, Avery Snyder</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Eddie Hanson, Gerald Adams</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Accountant, Marketing, Sales Management</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Partner at PwC, Partner, Partner, Business Transformation</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Director / Partner</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>https://www.linkedin.com/example66</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>example@gmail.com</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>Google, Microsoft</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>www.example.com</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>(555) 555-1234</label>
                          </div>
                          <div className="form-group customformheight">
                            <label>(555) 453-5334</label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-primary me-2 savebtn">Save</button>
                        </div>
                        <div className="col-md-6">
                          <button className="btn btn-light me-2 savebtn">Cancel</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Copyright © 2023 <a href="http://getbound.ai/">Getbound.ai</a> - All rights reserved</span>
            </div>
          </footer>
        </div>
      </div>
    </>
  )
}